import React from 'react';
import { NextIcon } from 'src/components';
import { IndicatorStep } from '../IndicatorStep';

type Props = {
  testID?:string;
  hasPosAgency:boolean;
  printIsReady:boolean;
  printErrors: Error | null;
  socketConnected: boolean;
  socketError:Error | null;
}

export const PrintIndicatorSteps: React.FC<Props> = ({ hasPosAgency, printIsReady, printErrors, socketConnected, socketError, testID='PrintIndicatorSteps', }) => {

    const finalServerError = socketError ? socketError : !socketConnected ? new Error('printer.socket-not-connected') : null;
    const finalPrintError = printErrors ? printErrors : !printIsReady ? new Error('printer.status-not-ready') : null;
    const finalAgencyError = !hasPosAgency ? new Error('pos.required-pos-agency') : null;
    const hasError = finalServerError || finalAgencyError || finalPrintError;

    const color = hasError ? 'border-error' : 'border-primary';
return <div data-testid={testID} className="flex flex-row space-x-2 justify-between my-4 items-start">
    <IndicatorStep  title='printer.print-indicator-mpo-printer-title' description='printer.print-indicator-mpo-printer-description' error={finalPrintError} />
    <hr  className={`text-gray-400 fill-current ${color} w-full mt-4`} />
    <IndicatorStep title="printer.print-indicator-mpo-socket-server-title" description='printer.print-indicator-mpo-socket-server-description' error={finalServerError} />
</div>
}